<template>
	<div :class="footerClass">
<!--		<span class="footer-text" style="margin-right: 5px">Parkdonate</span>-->
<!--		<img src="assets/layout/images/logo/logo.svg" alt="sigma" width="80"/>-->
		<span class="footer-text" style="margin-left: 5px">Copyright © 2020 Parkonomy Ltd. All Rights Reserved.</span>
	</div>
</template>

<script>
	export default {
		computed:{
			footerClass() {
				return ['layout-footer', {
					'layout-footer-dark': this.$store.state.theme === 'dark',
					'layout-footer-light': this.$store.state.theme === 'light'
				}];
			},
		},
		name: "AppFooter"
	}
</script>

<style scoped>

</style>